<template>
    <rkm-form
        v-if="loaded"
        ref="Form"
    >
        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Configurações gerais"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.numeroSolicitacaoAutomatico">
                                Número de solicitação automático
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.solicitacaoAutomaticaAmbulatorio">
                                Solicitação automática (Ambulatório)
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.permiteAgendarForaOrdemPosicao">
                                Permite agendar fora da ordem de posição
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.solicitacaoRetroativa">
                                Permite solicitação retroativa
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.examesNaoRegulados">
                                Controla exames não regulados
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.sempreAlterarUnidadeSolicitante">
                                Permite selecionar a unidade solicitante
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.encerraSolicitacaoAutomaticamenteAoEncerrarProtocoloOci">
                                Encerra automaticamente a solicitação ao encerrar o protocolo (OCI)
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox
                                tooltip-text="Quando habilitado, o Relatório de Solicitações exibirá área de assinatura no documento impresso."
                                v-model="model.exibeAssinaturaRelatorioSolicitacao"
                            >
                                Exibir assinatura no Relatório de Solicitações
                            </rkm-form-checkbox>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="auto">
                            <rkm-form-input
                                :validations="validations.validadeProcedimentoRealizado"
                                append="Dias"
                                label="Validade de procedimento realizado"
                                tooltip-top="Quantidade de dias considerada para verificação de procedimentos realizados pela fila da regulação."
                                type="number"
                                v-model="model.validadeProcedimentoRealizado"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Prontuário estadual (CROSS)"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.exibeProtocoloCross">
                                Exibir Protocolo
                            </rkm-form-checkbox>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.obrigaProtocoloCross">
                                Obrigar preenchimento
                            </rkm-form-checkbox>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col>
                <Supervisor :data="{ model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Regulador :data="{ form: form.regulador, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Solicitante :data="{ form: form.solicitante, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <PrestadorInterno :data="{ form: form.prestadorInterno, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <PrestadorExterno :data="{ form: form.prestadorExterno, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <DataDesejada :data="{ form: form.dataDesejada, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Divulgacao :data="{ form: form.divulgacao, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <PortalTransparencia :data="{ form: form.portalTransparencia, model }" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.opcoesRetiradaProtocoloAgendamento"
                    label="Retirada de protocolo agendamento (Padrão)"
                    text-field="nome"
                    v-model="model.opcaoRetiradaProtocoloAgendamentoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.estados"
                    label="Somente profissionais com registro em"
                    show-default-option
                    text-field="descricao"
                    v-model="model.usuarioRegistroEstadoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.mensagemProtocoloSolicitacao"
                    label="Mensagem de protocolo de cadastro de solicitação"
                    v-model="model.mensagemProtocoloSolicitacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.mensagemComprovanteAgendamento"
                    label="Mensagem de comprovante de agendamento"
                    v-model="model.mensagemComprovanteAgendamento"
                />
            </rkm-col>
        </rkm-row>

        <rkm-area
            title="Integrações de Aplicativos"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-checkbox v-model="model.integracaoAplicativo.habilitaConectasusCidadao">
                        Habilitar a funcionalidade Meus Encaminhamentos no App Cidadão
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Components.
import Supervisor from './components/supervisor/Index'
import Regulador from './components/regulador/Index'
import Divulgacao from './components/divulgacao/Index'
import Solicitante from './components/solicitante/Index'
import PrestadorInterno from './components/prestador-interno/Index'
import PrestadorExterno from './components/prestador-externo/Index'
import DataDesejada from './components/data-desejada/Index'
import PortalTransparencia from './components/portal-transparencia/Index'

// Mixins.
import { repository, error, object, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Supervisor,
        Regulador,
        Divulgacao,
        Solicitante,
        PrestadorInterno,
        PrestadorExterno,
        DataDesejada,
        PortalTransparencia,
    },
    computed: {
        validations() {

            return {
                mensagemProtocoloSolicitacao: { max: 500 },
                mensagemComprovanteAgendamento: { max: 500 },
                validadeProcedimentoRealizado: { min_value: 1, max_value: 9999 },
            }
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.$emit('data-load', { form: this.form, model: this.model })

                    this.loaded = true;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(() => {

                            this.showSaveNotification('Registro salvo com sucesso!<br>Configuração do Portal da Transparência atualizada com sucesso.')
                            this.$emit('save')
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.supervisores = data.supervisores.map(supervisor => ({
                id: supervisor.id,
                usuarioId: supervisor.usuario.id,
            }))

            data.reguladores = data.reguladores.map(regulador => ({
                id: regulador.id,
                ativo: regulador.ativo,
                infraestruturaId: regulador.infraestruturaId,
                tipoId: regulador.tipoId,
                solicitanteControlaProtocoloFechamento: regulador.solicitanteControlaProtocoloFechamento,
                exames: regulador.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                    exigeDocumentoAnexo: exame.exigeDocumentoAnexo,
                })),
                procedimentosCirurgicos: regulador.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                    exigeDocumentoAnexo: procedimentoCirurgico.exigeDocumentoAnexo,
                })),
                especialidades: regulador.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                    exigeDocumentoAnexo: especialidade.exigeDocumentoAnexo,
                })),
            }))

            data.divulgacao = data.divulgacao.map(divulgar => ({
                id: divulgar.id,
                ativo: divulgar.ativo,
                infraestruturaId: divulgar.infraestruturaId,
                solicitanteControlaProtocoloFechamento: divulgar.solicitanteControlaProtocoloFechamento,
                exames: divulgar.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                })),
                procedimentosCirurgicos: divulgar.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                })),
                especialidades: divulgar.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                })),
            }))

            data.solicitantes = data.solicitantes.map(solicitante => ({
                id: solicitante.id,
                infraestruturaId: solicitante.infraestruturaId,
                isPpi: solicitante.isPpi,
                atendeOutroMunicipio: solicitante.atendeOutroMunicipio,
                reguladores: solicitante.reguladores.map(regulador => ({
                    id: regulador.id,
                    infraestruturaId: regulador.infraestruturaId,
                    exames: regulador.exames.map(e => e.id),
                    procedimentosCirurgicos: regulador.procedimentosCirurgicos.map(pc => pc.id),
                    especialidades: regulador.especialidades.map(e => e.id),
                }))
            }))

            data.prestadoresInternos = data.prestadoresInternos.map(prestador => ({
                id: prestador.id,
                controlaProtocoloFechamento: prestador.controlaProtocoloFechamento,
                ativo: prestador.ativo,
                infraestruturaId: prestador.infraestruturaId,
                exames: prestador.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                    observacoes: exame.observacoes,
                })),
                procedimentosCirurgicos: prestador.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                    observacoes: procedimentoCirurgico.observacoes,
                })),
                especialidades: prestador.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                    observacoes: especialidade.observacoes,
                })),
            }))

            data.prestadoresExternos = data.prestadoresExternos.map(prestador => ({
                id: prestador.id,
                ativo: prestador.ativo,
                destinoId: prestador.destinoId,
                exames: prestador.exames.map(exame => ({
                    id: exame.id,
                    ativo: exame.ativo,
                    observacoes: exame.observacoes,
                })),
                procedimentosCirurgicos: prestador.procedimentosCirurgicos.map(procedimentoCirurgico => ({
                    id: procedimentoCirurgico.id,
                    ativo: procedimentoCirurgico.ativo,
                    observacoes: procedimentoCirurgico.observacoes,
                })),
                especialidades: prestador.especialidades.map(especialidade => ({
                    id: especialidade.id,
                    ativo: especialidade.ativo,
                    observacoes: especialidade.observacoes,
                })),
            }))

            data.dataDesejadaGruposExames = data.dataDesejadaGruposExames.map(g => g.id)
            data.dataDesejadaProcedimentosCirurgicos = data.dataDesejadaProcedimentosCirurgicos.map(p => p.id)
            data.dataDesejadaEspecialidades = data.dataDesejadaEspecialidades.map(e => e.id)
            data.dataDesejadaInfraestruturas = data.dataDesejadaInfraestruturas.map(i => i.id)

            data.portalTransparencia.abas.solicitacaoEspera.colunas = data.portalTransparencia
                .abas.solicitacaoEspera.colunas.map(coluna => ({
                    id: coluna.id,
                    visivel: coluna.visivel,
                }))

            data.portalTransparencia.abas.solicitacaoEspera.statusTipos = data.portalTransparencia
                .abas.solicitacaoEspera.statusTipos.map(statusTipo => ({
                    id: statusTipo.id,
                    visivel: statusTipo.visivel,
                }))

            data.portalTransparencia.abas.solicitacaoAtendida.colunas = data.portalTransparencia
                .abas.solicitacaoAtendida.colunas.map(coluna => ({
                    id: coluna.id,
                    visivel: coluna.visivel,
                }))

            data.portalTransparencia.abas.solicitacaoAtendida.statusTipos = data.portalTransparencia
                .abas.solicitacaoAtendida.statusTipos.map(statusTipo => ({
                    id: statusTipo.id,
                    visivel: statusTipo.visivel,
                }))

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, error, object, stringCase],
}
</script>